import AContainer from "../../library/ExtendedObjects/AContainer.js";

export default class BonusTimer extends AContainer
{
    constructor(scene, x, y)
    {
        super(scene, x, y);

        this.scene.add.existing(this);

        this.background = this.scene.addCirc(0, 0, 50, 0x000000, this);
        this.timerGraphic = this.scene.addSlice(0, 0, 50, -90, 0, false, 0xffffff, this);
        this.isComplete = true;

        this.create(0, 0, "Bonus_TmrFrnt");
    }

    startTimer(time, onComplete)
    {
        this.currentTime = this.lastTick = 0;
        this.endTime = time * 1000;
        this.isComplete = false;
        this.onComplete = onComplete;
        this.updateTimerGraphic(1);
    }

    preUpdate(time, deltaTime)
    {
        if(this.isComplete) return;
        this.currentTime += deltaTime;

        if(this.currentTime > this.lastTick + 100)
        {
            let normalizedTime = (this.currentTime / this.endTime);
            if(normalizedTime > 1) 
            {
                normalizedTime = .9999;
                this.isComplete = true;
                this.onComplete();
            }

            this.lastTick = this.currentTime;
            this.updateTimerGraphic(normalizedTime)
        }
    }

    updateTimerGraphic(normalizedTime)
    {
        let endAngle =  360 * normalizedTime;

        this.timerGraphic.clear();
        this.timerGraphic.fillStyle(0xffffff, 1);
        this.timerGraphic.slice(0, 0, 50, Phaser.Math.DegToRad(-90), Phaser.Math.DegToRad(endAngle - 90), true);
        this.timerGraphic.fillPath();
    }
}